define('controller/GdprReportController',['require','lib/controller/BaseController','model/GdprReportModel','view/controller/gdpr-report/GdprReportLayoutView','Config','lib/view/ModalRegion','view/controller/gdpr-report/GdprReportConfirmationView','model/GdprReportModuleModel','lib/plugin/PluginBroker','lib/WindowMessageListener'],function (require) {

    var BaseController = require('lib/controller/BaseController');
    var GdprReportModel = require('model/GdprReportModel');
    var GdprReportLayoutView = require('view/controller/gdpr-report/GdprReportLayoutView');
   // var ClientModel = require('model/ClientModel');
    var Config = require('Config');

    // views and models from GdprReportModel to reuse confirmation code
    var ModalRegion = require('lib/view/ModalRegion');
    var ConfirmationView = require('view/controller/gdpr-report/GdprReportConfirmationView');
    var GdprReportModuleModel = require('model/GdprReportModuleModel');

    var PluginBroker = require('lib/plugin/PluginBroker');
    var WindowMessageListener = require('lib/WindowMessageListener');

    /**
     * GDPR Controller
     *
     * @class GdprController
     */
    return BaseController.extend({

        _name : 'GdprController',

        _collection: null,
        _gdprReportModel: null,
        _clientModel: null,
        _modelReady : false,

        /**
         * Initialize controller object
         */
        initialize: function () {
            BaseController.prototype.initialize.apply(this);

            this.initOpenIdAuth();
        },

        /**
         * index action, displays list of images
         */
        index: function() {
            var instance = this;

            if (!this._gdprReportModel) {
                this._gdprReportModel = new GdprReportModel();
                this._gdprReportModel.on('sync', function() {
                    instance._modelReady = true;

                    if (instance._gdprReportModel.get('id')) {
                        _.delay(function () {
                            instance._gdprReportModel.fetch();
                        }, 210000);
                    } else {
                        GdprReportModuleModel.getInstance().logout();
                    }
                });
                this._gdprReportModel.fetch();
            }

            if (!this._clientModel) {
                if (Config.getInstance().getPluginStatus('client_login')) {
                    var clientPlugin = PluginBroker.getInstance().getPlugin('client_login');
                    this._clientModel = clientPlugin.getClientModel();
                }
            }

            this._showView();

            var gdprChannel = Backbone.Wreqr.radio.channel('gdpr');

            gdprChannel.vent.on('clientLogged', function () {
                instance._gdprReportModel.fetch({reset:true});
            });

            this.listenTo(this._clientModel, 'change', this.clientModelChanged);
        },

        _showView: function () {
            var indexView = new GdprReportLayoutView({
                gdprReportModel: this._gdprReportModel,
                clientModel: this._clientModel,
            });

            this.listenTo(indexView, 'confirmation_required', this._askForConfirmationCode);

            this.getMainLayout().getContentRegion().show(indexView);
        },

        clientModelChanged : function () {
            if(this._modelReady){
                var isLoggedIn = this._clientModel.get('is_logged_in');
                var id = this._gdprReportModel.get('id');

                if(!id !== !isLoggedIn){
                    this._gdprReportModel.fetch({reset:true});
                }
            }
        },

        /**
         * Subscribe to message window event
         */
        initOpenIdAuth: function () {
            var listener = new WindowMessageListener();
            this.listenTo(listener, 'message', _.bind(this._handleWindowMessage, this));
        },

        /**
         * Handle open id login message
         *
         * @private
         */
        _handleWindowMessage: function (data) {
            if (data.gdpr_open_id_message) {
               if (this._gdprReportModel) {
                   this._gdprReportModel.fetch();
               }
            }
        },

        _askForConfirmationCode: function () {
            this._isConfirmed = false;

            var model = new GdprReportModuleModel({
                is_form_active: true
            });

            var region = this._confirmationRegion = new ModalRegion();
            var view = new ConfirmationView({
                model: model
            });

            this.listenTo(view, 'code_confirmed', this._onCodeConfirmed);

            // @see https://github.com/twbs/bootstrap/issues/3902
            // > My workaround was to do a $('body') and see if it has the class 'modal-open'. If not -> open the modal.
            // > If yes, subscribe the .one('hidden.bs.modal', function(){ open the modal}) and call close() first

            if (region.$el.is(':visible')) {
                // wait until previous modal is finished hiding
                _.delay(function () {
                    region.show(view);
                }, 1500);
            } else {
                region.show(view);
            }

            if (this._gdprReportModel.get('id')) {
                // user logged in, but has not confirmed code; prefill email/phone

                var emailRequired = Config.getInstance().getOption('client_email_required');
                var phoneRequired = Config.getInstance().getOption('client_phone_required');

                if (emailRequired) {
                    model.set('preset', 'email');
                } else if (phoneRequired) {
                    model.set('preset', 'phone');
                }
                view.sendCounter = 1;
                view._submit();
                //TODO remove - saved by view in _submit()
                // model.save(null, { //TODO why doesn't this apply automatically?
                //     error: function (model, xhr) {
                //         model.onError(model, xhr);
                //     }
                // });
            } else {
                // not logged in - ask for email/phone
            }
        },

        _onCodeConfirmed: function () {
            this._isConfirmed = true;
            this._confirmationRegion.hide();
            if (this._gdprReportModel) {
                this._gdprReportModel.fetch();
            }
        }

    });

});

